import { render, staticRenderFns } from "./list.vue?vue&type=template&id=303bc452&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=303bc452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303bc452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('303bc452')) {
      api.createRecord('303bc452', component.options)
    } else {
      api.reload('303bc452', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=303bc452&scoped=true&", function () {
      api.rerender('303bc452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/fullNode/list.vue"
export default component.exports